/* eslint-disable react/jsx-no-useless-fragment */
import { Canvas } from '@studio/design-system/canvas';
import type { CanvasContext } from '@studio/design-system/canvas';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';
import { useWiring } from './wiring.js';
import { locateProxy } from '#~/agent/utils.js';

/** `<Joystick>` component. */
export const Joystick = ({ className, deviceId, origin, ...props }: Props): ReactElement => {
  const canvasRef = useRef<CanvasContext>(null);
  const wiring = useWiring(deviceId, origin, canvasRef);

  const proxy = locateProxy(deviceId);

  const capabilities = proxy?.state.status?.device[deviceId]?.capabilities;

  if (
    !capabilities?.movement?.vectors?.pan?.enabled &&
    !capabilities?.movement?.vectors?.tilt?.enabled
  ) {
    return <></>;
  }

  return (
    <Canvas
      className={twMerge('fixed inset-0 z-50 cursor-none', className)}
      onDraw={wiring.handleDrawCanvas}
      onPointerMove={wiring.handlePointerEvent}
      onWheel={wiring.handleWheelEvent}
      ref={canvasRef}
      {...props}
    />
  );
};
